// extracted by mini-css-extract-plugin
module.exports = {"app-font-size":"16","breakpoint":"breakpoint","number-lines":"number-lines","author":"U0Fjh3","author__image":"IWl4Ul"};